import './index.css'

import App from './App.tsx'
import { HashRouter } from 'react-router'
import { LanguageProvider } from './i18n/LanguageContext'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </HashRouter>
  </StrictMode>,
)